/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/destructuring-assignment */
import React from "react";
import { withRouter } from "react-router-dom";
import Error from "layouts/error";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, pathname: props.location.pathname };
  }

  static getDerivedStateFromProps(props, state) {
    // Reset the boundary whenever navigation happens, otherwise it would
    // keep rendering the error page forever, even after navigating away.
    if (props.location.pathname !== state.pathname) {
      return { hasError: false, pathname: props.location.pathname };
    }
    return null;
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ hasError: true });
    // Send Log Redux...
  }

  render() {
    if (this.state.hasError) {
      return <Error />;
    }

    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);
